import { useEffect, useState } from "react";
import initializeAuthentication from "../Firebase/firebase.init";
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, createUserWithEmailAndPassword,signInWithEmailAndPassword, signOut} from "firebase/auth";

initializeAuthentication();
const useFirebase =()=>{
  const [user, setUser]= useState({});
  const [error, setError]= useState('');
  const auth = getAuth();

   const googleProvider= new GoogleAuthProvider();
   const signInUsingGoogle=()=>{
     signInWithPopup(auth, googleProvider)
     .then(result=>{
         setUser(result.user);
     })
     .catch(error=>{
         setError(error.message);
     })
   }
   const logout = ()=>{
     signOut(auth)
     .then(()=>{
       setUser({});
     })
   }

//  login with register
  const handleUserRegister = (email, password)=>{
    createUserWithEmailAndPassword(auth, email, password)
    .then((result) => {
      // Signed in 
      setUser(result.user)
      
      // ...
    })
    .catch((error) => { 
      const errorMessage = error.message;
      // ..
    });
  };
//  login with email and password
  const handleUserLoginWithEmail=(email, password)=>{
    signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in 
      // const user = userCredential.user;
      setUser(userCredential.user)
      // ...
    })
    .catch((error) => {
      const errorMessage = error.message;
    });
  }


// observe user state change
   useEffect(()=>{
    const unsubscribed =  onAuthStateChanged(auth, user=>{
       if(user){
         setUser(user);
       }
       else{
         setUser({})
       }
     });
     return ()=>unsubscribed;
   }, [])

  return {
      user,
      logout,
      error,
      signInUsingGoogle,
      handleUserLoginWithEmail,
      handleUserRegister
  }
}
export default useFirebase;